import { CerFormAdapter } from '@form/cer-form-adapter';
import { CerFormView } from '@form/cer-form-view';

export class ExchangePartyForm extends CerFormAdapter {

  public override view(): CerFormView {
    return new CerFormView({
      title: 'Udvekslingsparter',
      mandatory: true,
      viewMetadata: {
        dataApiName: 'ExchangeParty',
        name: 'data-udveksling-parter', text: 'Udvekslingsparter',
        primaryKey: 'id',
        allowEdit: true, allowCreate: true, allowDelete: false,
        baseFields: ['id', 'history'],
        navigations: [
          { link: 'nav', foreignKey: { entity: 'ExchangeTypeSubscriber', column: 'exchangeParty', parentColumn: 'id' } }
        ]
      },
      fieldMetadata: [
        { name: 'name', text: 'Navn', required: true },
        { name: 'commerceParty', text: 'Egen part', format: 'CheckBox', defaultValue: false }
      ]
    });
  }
}
